import Grid from '@mui/material/Grid';
import { type CICaseDetail } from 'components/CriticalIncident/interfaces';
import { computeTotalTime } from 'components/CriticalIncident/utils/CaseSummaryUtils';
import { LabelValue } from 'components/Shared/LabelValue';
import { type FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { CICard } from '../../Shared/CICard/CICard';
import { DateRangeWidget } from '../../DateRangeWidget';
import { TimezoneDiffAlert } from '../../TimezoneDiffAlert';

export const InterventionCard: FunctionComponent<{ ciCase: CICaseDetail }> = ({ ciCase }) => {
    const { t } = useTranslation('criticalIncident', { useSuspense: false });

    return (
        <CICard className='case_summary_paper'>
            <h3>{t('intervention')}</h3>
            <TimezoneDiffAlert clientTimezone={ciCase.intervention?.olsonName ?? undefined} />
            <Grid container>
                <Grid item xs={12} sm={6}>
                    <DateRangeWidget startDate={ciCase.intervention?.startDateTime} endDate={ciCase.intervention?.endDateTime} clientTimezone={ciCase.intervention?.olsonName ?? undefined} inline />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <LabelValue label={t('modality')} value={t(ciCase.intervention?.modalityCode)}></LabelValue>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={12} sm={6}>
                    <LabelValue
                        label={t('duration')}
                        className='with-capitalized-value'
                        value={computeTotalTime(t, ciCase.intervention?.startDateTime, ciCase.intervention?.endDateTime)}
                    ></LabelValue>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <LabelValue label={t('language_of_service')} value={ciCase.intervention?.languagePreferences?.[0]}></LabelValue>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <LabelValue label={t('additional_details')} value={ciCase?.intervention?.onSiteInstruction}></LabelValue>
                </Grid>
                <Grid item xs={12}>
                    <LabelValue
                        label={t('location')}
                        value={ciCase.intervention?.location}
                    />
                </Grid>
            </Grid>
        </CICard>
    );
};
